import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuthToken } from './authToken';

const auth = () => ({ Authorization: 'Bearer ' + getAuthToken() });
export type BankPay = { due_date: string; bank_account_id: string };
const lab: any = { fontSize: 11, color: '#6b7280', marginBottom: 3, display: 'block' };
const inp: any = { width: '100%', padding: '6px 9px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box', fontFamily: 'inherit' };

export const plusDays = (n: number) => {
  const d = new Date(); d.setDate(d.getDate() + n);
  const p = (x: number) => (x < 10 ? '0' : '') + x;
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
};

// Termin platnosci (kalendarz) + konto bankowe (z Ustawienia -> Moje konto) dla platnosci przelewem
export default function BankPaymentFields({ API, value, onChange }: { API: string; value: BankPay; onChange: (v: BankPay) => void }) {
  const [accounts, setAccounts] = useState<any[] | null>(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    axios.get(API + '/settings/bank-accounts', { headers: auth() })
      .then((r: any) => {
        const l = r.data.accounts || [];
        setAccounts(l);
        if (!value.bank_account_id && l.length) {
          const d = l.find((a: any) => a.is_default) || (l.length === 1 ? l[0] : null);
          if (d) onChange({ ...value, bank_account_id: d.id });
        }
      })
      .catch(() => { setAccounts([]); setErr('Nie udało się pobrać kont bankowych.'); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [API]);
  const sel = (accounts || []).find((a: any) => a.id === value.bank_account_id);
  return (
    <div style={{ marginTop: 10, padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8 }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(150px, 1fr) minmax(220px, 2fr)', gap: 10 }}>
        <div>
          <label style={lab}>Termin płatności</label>
          <input type="date" value={value.due_date} onChange={(e) => onChange({ ...value, due_date: e.target.value })} style={inp} />
        </div>
        <div>
          <label style={lab}>Konto do płatności</label>
          <select value={value.bank_account_id} onChange={(e) => onChange({ ...value, bank_account_id: e.target.value })} style={inp}>
            <option value="">{accounts && accounts.length === 0 ? '— brak kont (Ustawienia → Moje konto) —' : '— wybierz konto —'}</option>
            {(accounts || []).map((a: any) => <option key={a.id} value={a.id}>{(a.description ? a.description + ' — ' : '') + a.number}</option>)}
            {value.bank_account_id && accounts && !sel ? <option value={value.bank_account_id}>konto zapisane w zamówieniu</option> : null}
          </select>
        </div>
      </div>
      {sel ? (
        <div style={{ marginTop: 8, fontSize: 13 }}>
          <span style={{ fontFamily: 'monospace', fontWeight: 600 }}>{sel.number}</span>
          {sel.description ? <span style={{ color: '#6b7280' }}> · {sel.description}</span> : null}
        </div>
      ) : null}
      {err ? <div style={{ fontSize: 12, color: '#b91c1c', marginTop: 6 }}>{err}</div> : null}
    </div>
  );
}
